/**
 * /* cSpell:disable
 *
 * @format
 */

import ActionTypes from './actionType';

// 1.定义默认数据
let initialState = {
  userId: '',
  username: '',
  userImage:
    'https://lskreno-typora.oss-cn-beijing.aliyuncs.com/img/avatar.png',
  signature: 'Not logged in yet',
};

// action creators
export const actions = {
  // 异步 action，执行登录验证
  login: userInfo => ({
    type: ActionTypes.CHANGE_USER,
    username: userInfo.username,
    userId: userInfo.userId,
    userImage: userInfo.userImage,
    signature: userInfo.signature,
  }),
  logout: () => ({ type: ActionTypes.LOGOUT }),
};

// 2.Reducer
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CHANGE_USERIMAGE:
      return { ...state, userImage: action.userImage };
    case ActionTypes.CHANGE_USERID:
      return { ...state, userId: action.userId };
    case ActionTypes.CHANGE_USER:
      return {
        ...state,
        username: action.username,
        userId: action.userId,
        userImage: action.userImage,
        signature: action.signature,
      };
    case ActionTypes.LOGOUT:
      return {
        ...state,
        username: '',
        userId: '',
        userImage: '',
        signature: '',
      };
    default:
      return state;
  }
};

// 3.导出
export default userReducer;
